import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandSyseleven({
    height = 28,
    width = 90,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-syseleven-brand-logo'
                    : 'provider-syseleven-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandSyseleven"
            width={width}
        />
    );
}

export default AppLogoBrandSyseleven;
